import { CarrierSubmission } from '../types/carrier-submission';
import { Submission } from '../types/submission';

export interface CarrierSubmissionFieldConfigProps {
    isRequired: boolean;
    nestedRequiredFields?: string[];
}

export type CarrierSubmissionFieldKey = keyof CarrierSubmission | keyof Submission;

type CarrierSubmissionFieldsConfig = {
    [key in CarrierSubmissionFieldKey]?: CarrierSubmissionFieldConfigProps;
};

// **NOTE**: Nested fields might require mapping in @backend/src/domain/stp-extracted-field-resolver.ts
export const carrierSubmissionFieldsConfig: CarrierSubmissionFieldsConfig = {
    insuredName: { isRequired: true },
    agentName: { isRequired: true },
    coverageLines: { isRequired: true },
    dueDate: { isRequired: true },
    insuredMailingAddress: {
        isRequired: true,
        nestedRequiredFields: ['line1', 'city', 'postalCode', 'state', 'country'],
    },
    industry: { isRequired: true },
    sic: { isRequired: true },
    natureOfBusiness: { isRequired: true },
    fein: { isRequired: true },
    businessEmail: { isRequired: false },
};
